import { networkType, RPC_MAP } from "@/config";
import { SpheronSDK } from "@spheron/protocol-sdk";

const spheronSdk = new SpheronSDK("", "", networkType, {
  HTTP_URL: RPC_MAP[networkType].http,
  WSS_URL: RPC_MAP[networkType].wss,
});

export default spheronSdk;
